/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ScrollPage from "../../Components/scrollpageUp";
import "./Sav.css";

function Sav({ navigateWithTransition }) {
  const location = useLocation();

  const containerRef = useRef(null);
  const activeLinkRef = useRef(null);

  const handleNavigate = (path) => {
    navigateWithTransition(path);
  };

  useEffect(() => {
    if (activeLinkRef.current) {
      activeLinkRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [location.pathname]);

  return (
    <div className="ElemntsGroupPage">
      <ScrollPage />

      <nav className="PageHead">
        <ul className="PageHeadLink" ref={containerRef}>
          {[
            {
              path: "#",
              label: "Kit de nettoyage",
            },
            {
              path: "/sav/garantie",
              label: "Garantie",
            },
            {
              path: "/sav/service-apres-vente",
              label: "Service après-vente",
            },
            
          ].map((item) => {
            const active = location.pathname === item.path;

            return (
              <li key={item.path}>
                <a
                  ref={active ? activeLinkRef : null}
                  className={active ? "active" : ""}
                  onClick={() => handleNavigate(item.path)}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      <Outlet />
    </div>
  );
}

export default Sav;